import Api from "../api/api";

export default async (body) => {
  const { data } = await Api.post("favorite", body);
  return data;
};
